import { Box, Button, Center, Heading, HStack, Input, Select, Spinner, Text, useToast } from '@chakra-ui/react'
import { addDoc, collection } from 'firebase/firestore'
import moment from 'moment'
import React, { useState } from 'react'
import { db } from '../../Configs/firebase'
import { uploadFile } from '../../Utils/FirebaseStorage'

function AddDataTradingPlan({speaker, getData, setAdd, handleCancel}) {

    const [title, setTitle] = useState("")
	const [description, setDescription] = useState("")
	const [start, setStart] = useState()
	const [price, setPrice] = useState(0)
	const [image, setImage] = useState("")
	const [tags, setTags] = useState("")
	const [winRate, setWinrate] = useState(0)
	const [netProfit, setNetProfit] = useState(0)

    const [loading, setLoading] = useState(false)

    const toast = useToast()


    const handleNewData=async()=>{
		// console.log(addData,'in handle new data')
		const addData = {
			title: title,
			description: description,
			start: moment(start).valueOf(), 
			price: price,
			image: image,
			tags: tags,
			win_rate:winRate,
			net_profit:netProfit
		}
		//handle image upload first
		if(addData.title===undefined){
			setLoading(true)
		toast({
			title: 'Data is incomplete',
			description: "Please make sure to complete your datas",
			status: 'error',
			duration: 9000,
			isClosable: true,
		  })
		  setLoading(false)
		  return
		}
		try {
			setLoading(true)
			if(addData.tags){
				let text = (addData.tags)
				const lowerText = text.toLowerCase();
				addData.tags = lowerText.split(",");
			}
			const imageResult = await uploadFile(addData.title, "tradingplan", addData["image"]);
			addData.image = imageResult.image_original;
        	addData.thumbnail = imageResult.image_thumbnail;

			const docRef = await addDoc(collection(db, "tradingplan"), addData);
			console.log("Document written with ID: ", docRef.id);
			setLoading(false)
			getData()
			setAdd()
			setTitle("")
			setDescription("")
			setStart()
			setPrice(0)
			setImage("")
			setTags("")
		} catch (error) {
			console.log(error.message)
			toast({
				title: 'Error in saving data',
				description: error.message,
				status: 'error',
				duration: 9000,
				isClosable: true,
			  })
		}
		setLoading(false)
		
	}


  return (
    <Center>
			<Box width='3xl'>
			<Heading>Add New Trading Plan</Heading>
			
			<Input m='1' id='title' type='text' placeholder='Title' 
			onChange={(e)=>setTitle(e.target.value)}
			/>

			<Input m='1' id='description' type='text' placeholder='Description' 
			onChange={(e)=>setDescription(e.target.value)}
			/>
			
			<Text fontWeight="bold" fontSize="md">Time Start</Text>
			<Input m='1' id='start' type='datetime-local' placeholder='Description' 
			onChange={(e)=>setStart(e.target.value)}
			/>
			

			<Input m='1' id='price' type='number' placeholder='Price' 
			onChange={(e)=>setPrice(e.target.value)}
			/>

			<Box display="flex" flexDirection="row">
				<Input m='1' id='price' type='number' placeholder='Win Rate' 
				onChange={(e)=>setWinrate(e.target.value)}
				/>
				<Input m='1' id='price' type='number' placeholder='Net Profit' 
				onChange={(e)=>setNetProfit(e.target.value)}
				/>
			</Box>

			<Text fontWeight="bold" fontSize="md">Image</Text>
			<Input m='1' id='image' type='file' placeholder='Image URL' 
			onChange={(e)=>setImage(e.target.files[0])}
			/>
			
			<Input m='1' id='tags' type='text' placeholder='Tags(ex seminar, foodpreneur, business)' 
			onChange={(e)=>setTags(e.target.value)}
			/>
            {loading? (
                <Center>
                    <Spinner />
                </Center>
            ) : (
				<HStack spacing="3" m={3} align="center">
                <Button bgColor='green' onClick={()=>handleNewData()}>Save</Button>
                <Button bgColor='red' onClick={handleCancel}>Cancel</Button>
				</HStack>
            )}
		
			
			</Box>
			</Center>
  )
}

export default AddDataTradingPlan